import { CheckCircle2, Clock } from 'lucide-react';

export default function ClientsTable({ clients, title = "My Registered Clients" }) {
  return (
    <div className="p-4 mb-8 bg-white rounded-xl border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center mb-2">
        <h4 className="text-sm font-semibold">{title} ({clients?.length || 0})</h4>
        <select className="px-2 py-1 text-xs bg-white rounded-md border">
          <option>All</option>
          <option>Complete</option>
          <option>Pending</option>
        </select>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-2">User</th>
              <th className="py-2">Registered Date</th>
              <th className="py-2">Client Type</th>
              <th className="py-2">Earning Rate</th>
              <th className="py-2">Registration Status</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c, i) => (
              <tr key={c.name + i} className="text-gray-700 border-t">
                <td className="py-2">{c.name}</td>
                <td className="py-2">{c.date}</td>
                <td className="py-2">{c.type}</td>
                <td className="py-2">{c.rate}</td>
                <td className="py-2">
                  <span className={`px-2 py-1 inline-flex items-center gap-1 rounded-full text-[10px] font-medium ${c.status === 'Complete' ? 'text-emerald-700 bg-emerald-50' : 'text-amber-700 bg-amber-50'}`}>
                    {c.status === 'Complete' ? <CheckCircle2 size={12} /> : <Clock size={12} />} {c.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


